import {matchPath, useLocation} from 'react-router-dom';

import {sourcingRoutes} from '@dms/routes';

export enum SourcingType {
  CLASSIFIEDS = 'classifieds',
  AUCTIONS = 'auctions',
}

export function useSourcingType(): SourcingType {
  const location = useLocation();
  const isAuctionsListRoute = matchPath(
    {path: sourcingRoutes.auctions, end: false},
    location.pathname
  );
  const isAuctionDetailRoute = matchPath(sourcingRoutes.auctionDetail, location.pathname);

  return isAuctionsListRoute || isAuctionDetailRoute
    ? SourcingType.AUCTIONS
    : SourcingType.CLASSIFIEDS;
}
